import type { ColumnDef } from "@tanstack/react-table";
import type { UserDefinedFieldRow } from "../types/UserDefinedField";

const titleize = (s: string) =>
  s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const userDefinedFieldColumns: ColumnDef<UserDefinedFieldRow>[] = [
  { accessorKey: "label", header: "Label" },
  { accessorKey: "name", header: "Name" },
  {
    accessorKey: "variableType",
    header: "Type",
    cell: ({ getValue }) => titleize(getValue() as string),
  },
  {
    accessorKey: "context",
    header: "Context",
    cell: ({ getValue }) => titleize(getValue() as string),
  },
  {
    accessorKey: "required",
    header: "Required",
    cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
  },
];
